<template>
    <div>
        <template v-if="! loading">
            <b-row class="justify-content-center">
                <b-col class="px-0 pb-2 col-10 col-md-8 col-lg-6">
                    <b-card>
                        <b-card-title title-tag="h5" title="Account Restricted"></b-card-title>
                        <b-card-body class="px-0">
                            <b-card-text>Your members account has been restricted.</b-card-text>
                            <b-card-text v-html="phoneNumberMessage"></b-card-text>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        phoneNumberMessage() {
            const phoneNumber = "01455 285605";
            if (this.isMobileDevice()) {
                return `Please call the office on <a href="tel:${phoneNumber}">${phoneNumber}</a> during normal office hours to discuss why this has happened.`;
            } else {
                return `Please call the office on ${phoneNumber} during normal office hours to discuss why this has happened.`;
            }
        }
    },
    methods: {
        init() {
            this.loading = false;
        },
        isMobileDevice() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }
    },
    mounted() {
        this.loading = true;
        this.init();
    }
}
</script>